<script>
import CheckBoxIcon from "./CheckBoxIcon.vue";

/* eslint-disable vue/require-v-for-key */
export default {
    name: "SimpleEventLeftMenu",
    props: {
        allVenues: {
            type: Array,
            default: () => [],
        },
        venueName: {
            type: String,
            default: "",
        },
        eventType: {
            type: String,
            default: "",
        },
        step: null,
        route: null,
        showHolidays: {
            type: Boolean,
            default: false,
        },
        sellTickets: {
            type: Boolean,
            default: false,
        },
        isFree: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            actData: {},
            steps: [
                "Add event to venue",
                "Add dates",
                "Add holidays",
                "Tickets and price",
                "Add pricing",
                "Booking settings",
                "Simple event summary",
            ],
        };
    },
    methods: {
        getCurrentStepStatus(step) {
            const idx = this.steps.findIndex((el) => el === this.route);

            if (idx === step) {
                return "active";
            } if (step > idx) {
                return "remain";
            } if (step < idx) {
                return "passed";
            }
            return "";
        },
    },
    computed: {
        getEventTypeName() {
            const accEventType = this.actData?.eventType
                ? this.actData.eventType
                : "Event";

            return this.eventType !== ""
                ? this.eventType
                : accEventType;
        },
        showPrice() {
            return this.sellTickets && this.isFree || this.sellTickets && !this.isFree;
        },
    },
    mounted() {
        this.actData = this.$storage.getStorageSync("activity");
    },
    components: { CheckBoxIcon },
};
</script>

<template>
    <div class="pages-menu" data-test="sidebar-step">
        <div v-for="(v) in allVenues">
            <div class="venue-small-title my-2 mb-3" data-test="sidebar-step-venue">
                {{ v.venueName }}
            </div>
            <div v-if="v.venueName === venueName" class="pl-2">
                <div class="d-flex flex-row" data-test="sidebar-step-detail">
                    <CheckBoxIcon :status="getCurrentStepStatus(0)"/>

                    <div class="ml-1 mt-n1 " :class="{'font-weight-600': step === 1}" data-test="sidebar-step-text">
                        {{ getEventTypeName }} details
                    </div>
                </div>
                <div class="d-flex flex-row" data-test="sidebar-step-datetime">
                    <CheckBoxIcon :status="getCurrentStepStatus(1)"/>
                    <div class="ml-1 mt-n1 " :class="{'font-weight-600': step === 2}" data-test="sidebar-step-text">Date
                        and times
                    </div>
                </div>

                <div v-if="showHolidays" class="d-flex flex-row mt-n1" data-test="sidebar-step-holiday">
                    <CheckBoxIcon :status="getCurrentStepStatus(2)"/>

                    <div
                        class="ml-1 "
                        :class="{'font-weight-600': getCurrentStepStatus(2) === 'active'}"
                        data-test="sidebar-step-text"
                    >
                        Holiday
                    </div>
                </div>
                <div class="d-flex flex-row mt-n1" data-test="sidebar-step-price">
                    <CheckBoxIcon :status="getCurrentStepStatus(4)"/>

                    <div
                        class="ml-1 mt-n1 "
                        :class="{
                            'font-weight-600': getCurrentStepStatus(4) === 'active'
                        }"
                        data-test="sidebar-step-text"
                    >
                        Tickets and price
                    </div>
                </div>
                <div v-if="sellTickets" class="d-flex flex-row mt-n1" data-test="sidebar-step-booking-settings">
                    <CheckBoxIcon :status="getCurrentStepStatus(5)"/>

                    <div
                        class="ml-1 mt-n1 "
                        :class="{
                            'font-weight-600': getCurrentStepStatus(5) === 'active'
                        }"
                        data-test="sidebar-step-text"
                    >
                        Booking settings
                    </div>
                </div>
                <div class="d-flex flex-row mt-n1" data-test="sidebar-step-summary">
                    <CheckBoxIcon :status="getCurrentStepStatus(6)" :is-summary="true"/>

                    <div
                        class="ml-1 mt-n1 "
                        :class="{
                            'font-weight-600': getCurrentStepStatus(6) === 'active'
                        }"
                        data-test="sidebar-step-text"
                    >
                        Summary
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.circle-icon {
    margin-right: 8px;
}

.font-weight-600 {
    font-weight: 600;
}
</style>
